import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [showLogin, setShowLogin] = useState(false);

  // Ctrl + D or Cmd + D
  useEffect(() => {
    const handleKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "d") {
        e.preventDefault();
        setShowLogin(true);
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  // Long press
  const handleTouchStart = (e) => {
    const timeout = setTimeout(() => {
      setShowLogin(true);
    }, 1200);

    const cancel = () => clearTimeout(timeout);
    e.target.addEventListener("touchend", cancel, { once: true });
    e.target.addEventListener("touchmove", cancel, { once: true });
  };

  // Auto-hide after 10s
  useEffect(() => {
    if (showLogin) {
      const timer = setTimeout(() => setShowLogin(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [showLogin]);

  return (
    <header
      className="bg-green-700 text-white shadow-md"
      onTouchStart={handleTouchStart}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-center lg:justify-between relative">
        <h1 className="text-2xl md:text-3xl font-extrabold text-center lg:text-left tracking-wide">
          Aarogyam Homoeopathic Clinic
        </h1>

        {showLogin && (
          <Link
            to="/login"
            className="absolute top-4 right-4 lg:top-1/2 lg:-translate-y-1/2 bg-white text-green-700 px-4 py-2 rounded text-sm sm:text-base shadow hover:bg-green-100 transition"
          >
            Doctor's Login
          </Link>
        )}
      </div>
    </header>
  );
}
